import Vector2 from "../math/Vector2";
import GameObject from "./GameObject";

export default class Transform {

    gameObject: GameObject;
    position: Vector2 = Vector2.zero;
    rotation: Vector2 = Vector2.right;
    scale: Vector2 = new Vector2(16, 16);

    get forward() {return this.rotation.clone();}
    get back() {return this.rotation.rotate(Math.PI);}
    get right() {return this.rotation.rotate(Math.PI/2);}
    get left() {return this.rotation.rotate(-Math.PI/2);}

    constructor(gameObject: GameObject) {
        this.gameObject = gameObject;
    }

    toObject() {
        return {
            position: this.position.toObject(),
            rotation: this.rotation.toObject(),
            scale: this.scale.toObject()
        };
    }

}